/**
 * Created by pmnia on 02/03/15.
 */
/**
 * Created by pmnia on 02/03/15.
 */
(function (app) {
    'use strict';

    app.factory('associationServices', associationServices);
    /*@ngInject*/
    function associationServices(queryservice){
        return  {
            getAssociation:getAssociation,
            getTherapists: getTherapists
        };

        function getAssociation(cId) {
            if(cId){
                var fctArgsJson= {cId:cId};
                var fctName= "obtAdvHelper.getClinicInfo";
                return queryservice.callServer(fctName,fctArgsJson);
            }
        }

        function getTherapists(cId){
            if(cId){
                var fctArgsJson= {cId:cId};
                var fctName= "obtAdvHelper.getTherapistsInfoByLocations";
                return queryservice.callServer(fctName,fctArgsJson);
            }
        }
    }
})(angular.module('app.data'));



/*****************
 ** WEBPACK FOOTER
 ** ./app/data/association.services.js
 ** module id = 161
 ** module chunks = 0
 **/